export const colors = {
	background: {
		primary: '#E8E2DA',
		secondary: '#FFFFFF',
	},
	yellow: {
		bromma: '#FAF082',
		brommaLight: '#ffd75e',
		brommaDark: '#e6bc3e',
	},
	blue: {
		bromma: '#77A9FF',
		brommaLight: '#ABCAFF',
		brommaDark: '#0F2699',
		brommaDarker: '#030945',
		brommaDarkest: '#020422',
		light: '#edf3fe',
		digital: '#3264ff',
		digitalLight: '#4c79ff',
		digitalDark: '#2e5ce6',
	},
	purple: {
		normal: '#7d008c',
	},
	grey: {
		lightest: '#f5f5f5',
		light: '#ebe9ee',
		normal: '#cecfcf',
		dark: '#adadad',
		graphite: '#2d2b30',
	},
	green: {
		eco: '#00c06a',
		ecoLight: '#00d977',
		ecoDark: '#00a65b',
		light: '#d3ffe7',
	},
	orange: {
		spreader: '#e25303',
		spreaderLight: '#fc5e03',
		spreaderDark: '#c94b02',
	},
	red: {
		warningDark: '#FA4E56',
		warning: '#FA4E56',
		warningLight: '#FA8C91',
		light: '#FFB3B8',
	},
};

export const fonts = {
	primary: '"Akkurat", Arial, Helvetica, sans-serif',
	secondary: '"BrommaDisplay", Arial, Helvetica, sans-serif',
};

export const sidebarWidth = 240;
export const sidebarBreakpoint = 800;
export const footerHeight = 220;
export const topBarHeight = 72;
export const preHeaderHeight = 38;
export const totalHeaderHeight = preHeaderHeight + topBarHeight;



// WEBPACK FOOTER //
// ./src/components/variables.js